export default "__VITE_ASSET__c70f717c__"